module.exports = __webpack_public_path__ + "img/Js.f79e5693.png";